// Shared base-currency options for org-facing currency selectors (registration + Settings)
// and the instructor profile's venue-hire display. The backend Joi whitelist
// (org.controller.js schemaOrgCreate) and getStripeRates must stay in sync with this list.
// Do NOT add a 7th (non-2-decimal) currency here without backend rate support.
export const currencyOptions = [
  { code: "AUD", symbol: "$", name: "Australian Dollar" },
  { code: "USD", symbol: "$", name: "US Dollar" },
  { code: "EUR", symbol: "€", name: "Euro" },
  { code: "GBP", symbol: "£", name: "British Pound" },
  { code: "CAD", symbol: "$", name: "Canadian Dollar" },
  { code: "NZD", symbol: "$", name: "New Zealand Dollar" },
];
